__turbopack_context__.v({
  "SArticleSummary": "S4-sXa_SArticleSummary",
  "SContainer": "S4-sXa_SContainer",
  "SMainText": "S4-sXa_SMainText",
  "SSummaryButton": "S4-sXa_SSummaryButton",
  "SSummaryHeading": "S4-sXa_SSummaryHeading",
  "SSummaryList": "S4-sXa_SSummaryList",
  "ThemeDk": "S4-sXa_ThemeDk",
  "ThemeFw": "S4-sXa_ThemeFw",
  "showAll": "S4-sXa_showAll",
});
